import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import template from 'lodash/template';

import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';

import useLocale from 'components/useLocale';

import ModalNotification from '../modalNotification/ModalNotification';
import { useStyles } from './SessionExpiration.styles';

const ExpirationView = ({
  emulation,
  isApplicationTabHidden,
  onLogout,
  onResume,
  popupMode,
  sending,
  show,
  time
}) => {
  const locale = useLocale();
  const history = useHistory();
  const {
    actionBtns,
    centerPopupWindow,
    countDown,
    countDownLabel,
    instructions,
    modal,
    resumeBtn,
    timeRemaining
  } = useStyles();

  const resume = locale['sessionExpiration.resume'];
  const logout = locale['sessionExpiration.logout'];
  const instructionsTemplate = locale['sessionExpiration.buttonInstructionsTemplate'];

  const dangerousHTML = {
    __html: template(instructionsTemplate)({
      resume: `<b>${resume}</b>`,
      countEnd: '<b>0.</b>'
    })
  };

  return (
    <ModalNotification
      className={modal}
      closeButton={false}
      data-qa="session-expiration-alert"
      dialogClassName={classnames({ [centerPopupWindow]: popupMode && isApplicationTabHidden })}
      disableBackdropClick
      emulation={emulation}
      footer={
        <div className={actionBtns}>
          <Button
            className={classnames('btn btn-primary', resumeBtn)}
            data-qa="expiration-resume"
            disabled={sending}
            onClick={onResume}
            text={resume}
            variant={PRIMARY}
          />
          <Button
            className="btn btn-tertiary"
            data-qa="expiration-logout"
            disabled={sending}
            onClick={() => {
              onLogout({ history });
            }}
            text={logout}
            variant={TERTIARY}
          />
        </div>
      }
      hideBackdrop={isApplicationTabHidden}
      show={show}
      suppressIcon={false}
      variant="error"
    >
      <div className="modal-header">{locale['sessionExpiration.header']}</div>

      <div className={timeRemaining}>
        <span className={countDownLabel}>{locale['sessionExpiration.timeRemaining']}</span>
        <span className={countDown}>{time}</span>
      </div>

      <div
        className={instructions} // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={dangerousHTML}
      />
    </ModalNotification>
  );
};

ExpirationView.propTypes = {
  emulation: PropTypes.bool.isRequired,
  isApplicationTabHidden: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
  onResume: PropTypes.func.isRequired,
  popupMode: PropTypes.bool.isRequired,
  sending: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  time: PropTypes.string.isRequired
};

export default ExpirationView;
